/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { faFileExcel, faFileWord, faFileImage, faFilePdf, faFile } from "@fortawesome/free-solid-svg-icons";
import { Folder, MoreVertical } from "react-feather";
import moment from "moment";
import { humanDateFormat } from "../../../config/constants";
import { useAuth } from "../../context/AuthContext";
import modulos from "../../mocks/modulos";

export const getFileIconName = (mimetype) => {
  if (!mimetype) return faFile;
  if (mimetype.includes("pdf")) {
    return faFilePdf;
  }
  if (mimetype.includes("msword") || mimetype.includes("officedocument.wordprocessingml.document") || mimetype.includes("opendocument.text")) {
    return faFileWord;
  }
  if (mimetype.includes("ms-excel") || mimetype.includes("officedocument.spreadsheetml.sheet") || mimetype.includes("opendocument.spreadsheet")) {
    return faFileExcel;
  }
  if (mimetype.includes("image")) {
    return faFileImage;
  }
  return faFile;
};

const FileItem = ({ file, handleDeleteFile, handleDoubleClick, handleChangeFolderName, handleMoveFolderTo, handleDownloadFile, handleShareFolder }) => {
  const { linkToken, currentUser } = useAuth();
  const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.FILE_MANAGER);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const updatedAt = file.updatedAt ? moment(file.updatedAt).format(humanDateFormat) : "";
  const isMemberInFolderClient = !isAdmin && file.parentId == null && Number.isInteger(file.id);

  return (
    <tr className="btn-light" onDoubleClick={() => file.isFolder && handleDoubleClick(file.id)}>
      <td>{file.isFolder ? <Folder /> : <FontAwesomeIcon size="lg" icon={getFileIconName(file.mimetype)} />}</td>
      <td> {file.name} </td>
      <td> {updatedAt} </td>
      <td>
        {!file.isService && (
          <Dropdown isOpen={dropdownOpen} toggle={toggle} size="sm">
            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
              <MoreVertical />
            </DropdownToggle>
            <DropdownMenu right>
              {file.isFolder && (
                <>
                  <DropdownItem onClick={() => handleChangeFolderName(file)}> Cambiar nombre </DropdownItem>
                  <DropdownItem onClick={() => handleMoveFolderTo(file)}> Mover </DropdownItem>
                  {linkToken || isMemberInFolderClient ? <></> : <DropdownItem onClick={() => handleShareFolder(file)}> Compartir </DropdownItem>}
                </>
              )}
              {!file.isFolder && (
                <>
                  <DropdownItem onClick={() => handleDownloadFile(file)}> Descargar archivo </DropdownItem>
                  <DropdownItem onClick={() => handleDeleteFile(file)}> Eliminar archivo </DropdownItem>
                </>
              )}
            </DropdownMenu>
          </Dropdown>
        )}
      </td>
    </tr>
  );
};

export default FileItem;
